module.exports = __webpack_public_path__ + "30802ce69ee0f2efd1f6eb0374d129d9.svg";